import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function GradjanskoPravo() {
  return (
    <>
      <Navbar />
      <Bredcom
        title="Početna"
        subtitle="Građansko pravo opšti dio i Stvarno pravo"
      />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">
                Građansko pravo opšti dio i Stvarno pravo
              </h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Građansko pravo opšti dio i
                Stvarno pravo
              </p>
              <p>
                <strong>Nastavnik:</strong> Đuro Đurić
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 8
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Cilj predmeta Građansko pravo opšti dio i Stvarno pravo je
                upoznavanje studenata sa osnovnim pojmovima i načelima
                Građanskog prava kao i sa značajem civilnog prava za sigurnost
                pravnog i ekonomskog prometa. Osnovna znanja o građanskom pravu
                njegovim pojmovima predstavljaju osnovu pravne terminologije za
                ostale građansko pravne predmete koji će se izučavati u nastavku
                studija. Razvijanje praktičnih vještina u razumjevanju odnosa
                građanskog sa drugim granama prava, pogotovo krivičnog i
                ustavnog prava. U okviru nauke o stvarnom pravu cilj je upoznati
                studente sa stvarnim pravom kao objektivnim pravom te posebnim
                dijelom građanskog prava koji se izučava uobičajeno uz građansko
                pravo. Takođe je cilj upoznati studente sa stvarnim pravima u
                Crnoj Gori, načinima sticanja kao i sa sredstvima zaštite
                stvarnih prava.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Izučavanjem i polaganjem ovog predmeta studenti će steći osnovna
                znanja iz jedne od elementarnih i najpotrebnijih pravnih oblasti
                - građanskog prava, dok će takođe steći i temeljna i detaljna
                znanja iz oblasti stvarnog prava kao jednog od djelova
                građanskog prava. Takođe polaganjem ovog predmeta studenti će
                moći detaljnije i stručnije definisati i objasniti neke od
                osnovnih pojmova i instituta građanskopravnih pojmova koji će im
                u nastavku studija biti od izuzetnog značaja za savlađivanje
                drugih djelova i grana građanskog prava. Izučavanjem Stvarnog
                prava studenti će steći potpunija znanja iz niza pravnih
                instituta među kojima su: svojina, prava službenosti, realnih
                obezbjeđenja, registar nepokretnosti, državina kao i mnogi
                drugi. Studenti će takođe biti u mogućnosti da odrede koja su to
                pravna pravila relevantna za rješavanje konkretnog slučaja kao i
                da primijene određena pravna pravila na konkretne životne
                situacije i probleme.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                <strong>Teorijska nastava:</strong>
              </p>
              <ul className="values-section">
                <li>
                  Pojam predmet i metod građanskog prava; Izvori građanskog
                  prava
                </li>
                <li>
                  Fizička lica – pravna poslovna deliktna sposobnost i atributi
                </li>
                <li>
                  Pravna lica – pojam, funkcije, vrste, pravna, poslovna i
                  deliktna sposobnost i atributi
                </li>
                <li>Pojam obilježja i vrste subjektivnih građanskih prava</li>
                <li>
                  Pojam i funkcije imovine. Opšta imovina i posebne imovine
                </li>
                <li>
                  Pojam pravnog prometa; Singularna i univerzalna sukcesija
                  Derivativno i originerno sticanje Personalna subrogacija i
                  realna subrogacija
                </li>
                <li>
                  Pojam obilježja i vrste pravnih poslova; Nevažeći pravni
                  poslovi: ništavi i rušljivi poslovi konvalidacija i
                  konverzija; Modifikacije pravnih poslova
                </li>
                <li>
                  Pojam i vrste zastupništva; Građanskopravni delikti;
                  Zastarelost i prekluzija; Vršenje prava i zloupotreba prava
                </li>
                <li>
                  Povreda subjektivnog prava: pojam vrste i zaštita subjektivnog
                  prava; Sudska zaštita (tužbe, teret dokazivanja, pretpostavke
                  i fikcije, sudske odluke)
                </li>
                <li>
                  Pojam i karakteristike stvarnih prava; Pojam i podjele stvari;
                  Hartije od vrijednosti; Pojam i vrste državine; Sudska i
                  vansudska zaštita državine
                </li>
                <li>
                  Pojam karakteristike i značaj svojine; Ograničenja prava
                  svojine – susedska prava; Sticanje prava svojine; Priraštaj;
                  Održaj; Građenje na tuđem zemljištu; Okupacija; Zaštita
                  svojine (svojinske tužbe)
                </li>
                <li>
                  Pojam specifičnosti sticanje i zaštita državne svojine; Pravo
                  preče kupovine; Susvojina – pojam karakteristike sticanje
                  zaštita; Zajednička svojina – pojam i vrste; Etažna svojina –
                  pojam i specifičnosti sadržina sticanje i zaštita
                </li>
                <li>
                  Stvarne službenosti – pojam vrste sticanje zaštita; Lične
                  službenosti – pojam vrste sticanje zaštita; Realni tereti –
                  pojam sticanje zaštita; Ručna zaloga – pojam vrste sticanje
                  zaštita podzaloga; Zalaganje potraživanja i drugih prava;
                  Registrovana zaloga – pojam vrste sticanje zaštita; Podzalog;
                  Pravo retencije
                </li>
                <li>
                  Hipoteka – pojam vrste sticanje zaštita nathipoteka;
                  Fiducijarna svojina; Neakcesorna prava namirenja – realni
                  (zemljišni) dug; Pravo izgradnje; Zemljišnoknjižni sistem i
                  sistem jedinstvene evidencije; Katastar nepokretnosti; Pojam i
                  vrste zabilježbi; Digitalna imovina i njena obilježja prijenos
                  i raspolaganje
                </li>
              </ul>
              <p>
                <strong>Praktična nastava:</strong>
              </p>
              <ul className="values-section">
                <li>Analiza sudske prakse</li>
                <li>Pisanje podnesaka za zaštitu državine i svojine</li>
                <li>Pisanje pismena</li>
                <li>Debate</li>
                <li>Rad u grupama</li>
              </ul>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Nastava se izvodi kroz predavanja, diskusije, izrade samostalnih
                istraživačkih radova – seminarskih radova, upoznavanje sa
                sudskom praksom crnogorskih sudova (u sudu ili u okviru nastave
                na fakultetu) i analizu sudske prakse od strane studenata.
              </p>
              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>4P+3V</td>
                    <td>
                      Pojam predmet i metod građanskog prava; Izvori građanskog
                      prava; Fizička lica – pravna poslovna deliktna sposobnost
                      i atributi; Pravna lica – pojam, funkcije, vrste, pravna
                      poslovna i deliktna sposobnost i atributi
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>4P+3V</td>
                    <td>
                      Pojam obilježja i vrste subjektivnih građanskih prava;
                      Pojam i funkcije imovine. Opšta imovina i posebne imovine
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>4P+3V</td>
                    <td>
                      Pojam pravnog prometa; Singularna i univerzalna sukcesija,
                      Derivativno i originerno sticanje, Personalna subrogacija
                      i realna subrogacija
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>4P+3V</td>
                    <td>
                      Pojam obilježja i vrste pravnih poslova; Nevažeći pravni
                      poslovi: ništavi i rušljivi poslovi, konvalidacija i
                      konverzija; Modifikacije pravnih poslova
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>4P+3V</td>
                    <td>
                      Pojam i vrste zastupništva; Građanskopravni delikti;
                      Zastarelost i prekluzija; Vršenje prava i zloupotreba
                      prava
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>Kolokvijum I</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>4P+3V</td>
                    <td>
                      Povreda subjektivnog prava: pojam vrste i zaštita
                      subjektivnog prava; Sudska zaštita (tužbe, teret
                      dokazivanja, pretpostavke i fikcije, sudske odluke)
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>4P+3V</td>
                    <td>
                      Pojam i karakteristike stvarnih prava; Pojam i podjele
                      stvari; Hartije od vrijednosti; Pojam i vrste državine;
                      Sudska i vansudska zaštita državine
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>4P+3V</td>
                    <td>
                      Pojam karakteristike i značaj svojine; Ograničenja prava
                      svojine – susedska prava; Sticanje prava svojine;
                      Priraštaj; Održaj; Građenje na tuđem zemljištu; Okupacija;
                      Zaštita svojine (svojinske tužbe)
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>4P+3V</td>
                    <td>
                      Pojam specifičnosti sticanje i zaštita državne svojine;
                      Pravo preče kupovine; Susvojina – pojam karakteristike
                      sticanje zaštita
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>4P+3V</td>
                    <td>
                      Zajednička svojina – pojam i vrste; Etažna svojina – pojam
                      i specifičnosti sadržina sticanje i zaštita; Stvarne
                      službenosti – pojam vrste sticanje zaštita; Lične
                      službenosti – pojam vrste sticanje zaštita
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>Kolokvijum II</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>4P+3V</td>
                    <td>
                      Realni tereti – pojam sticanje zaštita; Ručna zaloga –
                      pojam vrste sticanje zaštita podzaloga; Zalaganje
                      potraživanja i drugih prava; Registrovana zaloga – pojam
                      vrste sticanje zaštita; Podzalog; Pravo retencije
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>4P+3V</td>
                    <td>
                      Hipoteka – pojam vrste sticanje zaštita nathipoteka;
                      Fiducijarna svojina; Neakcesorna prava namirenja – realni
                      (zemljišni) dug
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>4P+3V</td>
                    <td>
                      Pravo izgradnje; Zemljišnoknjižni sistem i sistem
                      jedinstvene evidencije; Katastar nepokretnosti; Pojam i
                      vrste zabilježbi
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 7č / 5.15h</td>
                            <td>Ukupno: 140h</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 4č / 3.00h</td>
                            <td>Nastava + završni ispit: 100h</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 3č / 2.15h</td>
                            <td>Priprema i ovjera semestra: 15h</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 25h</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default GradjanskoPravo;
